import React, { useState } from "react";
import { Link } from "react-router-dom";
import ArrowOutward from "@mui/icons-material/ArrowOutward";
import BrandLockup from "./BrandMark";
import ContactDialog from "./ContactDialog";
import { FooterSignature } from "./motion/Flourishes";
import "../styles/brand.css";
import "../styles/brand-motion.css";
const columns = [
  [
    "Explore",
    [
      ["Momentum", "/desktop"],
      ["Workspace", "/workspace"],
      ["Workers API", "/api"],
      ["Documentation", "/documentation"],
    ],
  ],
  [
    "The Lab",
    [
      ["About", "/about"],
      ["Vision", "/vision"],
      ["Manifesto", "/manifesto"],
      ["Careers", "/careers"],
      ["Journal", "/blog"],
    ],
  ],
  [
    "Connect",
    [
      ["Innovators", "/innovators"],
      ["Discord", "https://discord.gg/dDTem2P"],
      ["Get in touch", "mailto:team@grupa.ai"],
      ["Book a conversation", "https://calendar.app.google/CE8yHXidRV2hsSRS9"],
    ],
  ],
];

export default function Footer() {
  const [contactOpen, setContactOpen] = useState(false);
  return (
    <>
    <footer className="brand-footer">
      <div className="brand-footer-top brand-container">
        <div className="brand-footer-intro">
          <Link to="/" aria-label="GrupaAI home">
            <BrandLockup />
          </Link>
          <p>
            The operating system
            <br />
            for autonomous work.
          </p>
          <span className="brand-caption">Pioneer AI Lab</span>
        </div>
        {columns.map(([title, items]) => (
          <div className="brand-footer-column" key={title}>
            <h2>{title}</h2>
            {items.map(([label, to]) =>
              to.startsWith("/") ? (
                <Link key={label} to={to}>
                  {label}
                </Link>
              ) : to.startsWith("mailto:") ? (
                <React.Fragment key={label}>
                  <button type="button" className="brand-footer-contact-trigger" aria-haspopup="dialog" onClick={() => setContactOpen(true)}>
                    {label}<ArrowOutward fontSize="inherit" />
                  </button>
                  <noscript><a href={to}>team@grupa.ai</a></noscript>
                </React.Fragment>
              ) : (
                <a
                  key={label}
                  href={to}
                  target={to.startsWith("https") ? "_blank" : undefined}
                  rel="noreferrer"
                >
                  {label}
                  <ArrowOutward fontSize="inherit" />
                </a>
              ),
            )}
          </div>
        ))}
      </div>
      <div
        className="brand-footer-signature brand-container"
        aria-hidden="true"
      >
        <FooterSignature text="GrupaAI" />
      </div>
      <div className="brand-footer-bottom brand-container">
        <span>&copy; {new Date().getFullYear()} GrupaAI</span>
        <span>Built for what comes next.</span>
        <div>
          <Link to="/login">Existing users</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
        </div>
      </div>
    </footer>
    <ContactDialog open={contactOpen} onClose={() => setContactOpen(false)} />
    </>
  );
}
